// A pending invitation survives sign-in and a page refresh, but only in this tab.
const KEY = 'irecommend-pending-invite';

export const rememberInvite = (code, inviterName) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ code, inviterName }));
  } catch (err) {
    // Private-mode storage limits are not worth failing the flow over.
  }
};

export const readInvite = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
};

export const forgetInvite = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (err) {
    // Ignore.
  }
};
